<template>
  <v-text-field
    :label="placeholder"
    @input="inputChanged"
    v-if="isTextType"
    :value="initialValue"
    :disabled="isDisabled"
  />
  <user-multi-select
    v-else-if="isUserType"
    ref="users"
    :label="placeholder"
    :initialValue="initialValue"
    :disabled="isDisabled"
    @changed="userSelectionChanged"
  />
  <date-range-selection
    v-else-if="isDateRangeType"
    ref="daterange"
    @changed="onDateRangeSelected"
  />
  <machines-filter
    v-else-if="isMachinesType"
    ref="machines"
    @changed="onMachinesSelected"
  />
  <project-filter
    v-else-if="isProjectType"
    ref="project"
    @changed="onProjectSelected"
  />
</template>

<script>

import moment from 'moment';
// import DateRange from './DateRange';
import DateRangeSelection from './DateRangeSelection';
import MachinesFilter from './MachinesFilter';
import ProjectFilter from './ProjectFilter';
import UserMultiSelect from './UserMultiSelect';

export default {
  name: 'Filterbox',
  components: {
    DateRangeSelection,
    MachinesFilter,
    ProjectFilter,
    UserMultiSelect,
  },
  props: ['placeholder', 'type', 'onFilterSeleced', 'initialValue', 'selectItems', 'disabled'],
  computed: {
    isUserType() {
      return this.type === 'users';
    },
    isTextType() {
      return this.type === 'text';
    },
    isDateRangeType() {
      return this.type === 'daterange';
    },
    isProjectType() {
      return this.type === 'project';
    },
    isMachinesType() {
      return this.type === 'machines';
    },
    isDisabled() {
      return !!this.disabled;
    },
  },
  methods: {
    clear() {
      if (this.isUserType) {
        this.$refs.users.clear();
      }
      if (this.isDateRangeType) {
        this.$refs.daterange.clear();
      }
      if (this.isMachinesType) {
        this.$refs.machines.clear();
      }
      if (this.isProjectType) {
        this.$refs.project.clear();
      }
    },
    userSelectionChanged(val) {
      this.$emit('filter', val);
    },
    inputChanged(val) {
      this.$emit('filter', val);
    },
    onMachinesSelected(machines) {
      if (!machines || machines.length <= 0) {
        this.$emit('filter', null);
      } else {
        this.$emit('filter', machines);
      }
    },
    onProjectSelected(project) {
      this.$emit('filter', project);
    },
    onDateRangeSelected({from, to}) {
      this.$emit('filter', {from, to});
    },
    getInitialDateValue() {
      if (this.type === 'text' || !this.initialValue) {
        return null;
      }

      return moment(this.initialValue).format('YYYY-MM-DD');
    },
  },
  data() {
    return {
      date: this.getInitialDateValue(),
      menu: false,
      modal: false,
    };
  },
};
</script>
